import { render } from "./ConfigureHostOOBM.vue?vue&type=template&id=fc3d35f0&scoped=true"
import script from "./ConfigureHostOOBM.vue?vue&type=script&lang=js"
export * from "./ConfigureHostOOBM.vue?vue&type=script&lang=js"

import "./ConfigureHostOOBM.vue?vue&type=style&index=0&id=fc3d35f0&scoped=true&lang=css"

import exportComponent from "/opt/novus-cloud-ui/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc3d35f0"]])

export default __exports__